type RangeNumber = {
  Start: number;
  End: number;
};

/**
 * * Модель фильтра задач
 */
export class TaskFilterModel {
  /**Строка поиска */
  Search?: string;
  /**Список неймспейсов */
  Namespaces?: Array<string>;
  /**Список статусов */
  Statuses?: Array<number>;
  /**Список приоритетов */
  Priorities?: Array<number>;
  /**Список исполнителей */
  Performers?: Array<number>;
  /**Список наблюдателей */
  Observers?: Array<number>;
  /**Список авторов */
  Authors?: Array<number>;
  /**Список сложностей */
  Difficulties?: Array<string>;
  /**Список тегов */
  Tags?: Array<number>;
  /**Оценка времени */
  TimeEstimate: RangeNumber;
  /**Затраченное время */
  TimeSpent: RangeNumber;

  constructor(obj?: Partial<TaskFilterModel>) {
    Object.assign(this, obj);
  }
}
